import axios from 'axios';

export default (public_key, cartId) => ({
    stripe: null,

    cartId: null,

    card: null,

    clientSecret: null,

    adding: false,

    errors: null,

    init() {
        this.stripe = Stripe(public_key);
        const elements = this.stripe.elements();
        this.card = elements.create('card');

        this.card.on('change', event => {
            this.errors = false;

            const displayError = document.getElementById('card-errors');
            displayError.textContent = '';

            if (event.error) {
                this.errors = true;
                displayError.textContent = event.error.message;
            }
        });

        this.card.mount(document.getElementById('card-element'));
    },

    fetchSetupIntentClientSecret() {
        axios.post('/api/setup-intents', { cart_id: cartId })
            .then(({ data }) => {
                this.errors = false;
                this.clientSecret = data.client_secret;
                const displayError = document.getElementById('card-errors');
                if (displayError) {
                    displayError.textContent = '';
                }
            })
            .catch(() => {
                this.errors = true;
                const displayError = document.getElementById('card-errors');
                if (displayError) {
                    displayError.textContent = 'Unable to start card setup. Please try again.';
                }
            });
    },

    saveCard() {
        if (this.adding) return;

        const errorElement = document.getElementById('card-errors');

        if (!this.clientSecret) {
            this.errors = true;
            if (errorElement) {
                errorElement.textContent = 'Unable to save your card. Please try again.';
            }
            this.fetchSetupIntentClientSecret();
            return;
        }

        this.adding = true;
        this.errors = false;
        if (errorElement) {
            errorElement.textContent = '';
        }

        const card = this.card;

        this.stripe.confirmCardSetup(this.clientSecret, {
            payment_method: { card }
        }).then(result => {
            if (result.error) {
                errorElement.textContent = result.error.message;
                this.errors = true;
                this.adding = false;
                return;
            }

            this.$dispatch('setup-intent-created', result.setupIntent);
            this.adding = false;

        }).catch(error => {
            errorElement.textContent = 'There was an error. Please try again.';
            this.errors = true;
            this.adding = false;
        });
    }
});


